export default __webpack_public_path__ + "static/growth01-a81dab1bc6d3d419384f7bc048726cd0.jpg";